module.exports = __webpack_public_path__ + "img/history.0052d0e.svg";